import { Button, Input, List } from 'antd';
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import Action from "../../Classes/Action";
import { actionModalSliceDispatch, actionViewerSliceDispatch, pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import ActionModal from ".././ActionModal/ActionModal";

const ActionViewer = () => {
    const currentActions = useSelector((state: any) => state.pickAFile.actions);
    const currentRules = useSelector((state: any) => state.pickAFile.rules);
    const currentAddressStart = useSelector((state: any) => state.pickAFile.addressStart);

    const addModal = useSelector((state: any) => state.actionViewer.addModal);
    const editModal = useSelector((state: any) => state.actionViewer.editModal);

    const actionSearchResults = useSelector((state: any) => state.actionViewer.actionSearchResults);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    function DeleteAnAction(actionIdToDelete) {
        let filteredActions = currentActions.filter(action => action.actionId != actionIdToDelete);

        dispatch({ type: pickAFileSliceDispatch.setActions, payload: filteredActions })
        dispatch({ type: actionViewerSliceDispatch.setActionSearchResults, payload: filteredActions })

        CreateContentsFromStates({ actions: filteredActions });

        return filteredActions;
    }

    const HandleDelete = (event) => {
        DeleteAnAction(event.currentTarget.id)
    }

    const onActionSearchChange = (event) => {
        let searchValue = event.target.value.toLowerCase();

        let valueToUse = currentActions.filter(a => a.params?.some((p) => p.toLowerCase().includes(searchValue)));

        if (searchValue == "")
            dispatch({ type: actionViewerSliceDispatch.setActionSearchResults, payload: currentActions })
        else
            dispatch({ type: actionViewerSliceDispatch.setActionSearchResults, payload: valueToUse })
    }

    let maxIndex = currentAddressStart
    if (currentActions?.length > 0) {
        maxIndex = Math.max(...currentActions.map(o => o.actionId))
        maxIndex++
    }

    function getRuleTextFromEvent(actionEvent) {
        let splitResult = actionEvent.split("/")[0]

        let foundRule = currentRules.filter(p => p.event.type == splitResult)

        return foundRule ?
            (foundRule.length > 0 && foundRule[0].name) ?
                foundRule[0].name + " - " :
                "" :
            "";
    }

    const AddModal = (event?: any) => {
        dispatch({ type: actionViewerSliceDispatch.setAddModal, payload: true })
        dispatch({ type: actionViewerSliceDispatch.setEditModal, payload: false })
        dispatch({ type: actionModalSliceDispatch.setOpen, payload: true });
    }

    const EditModal = (event?: any) => {
        dispatch({ type: actionViewerSliceDispatch.setEditModal, payload: true })
        dispatch({ type: actionViewerSliceDispatch.setAddModal, payload: false })
        dispatch({ type: actionModalSliceDispatch.setOpen, payload: true });
    }

    const allActions =
        <div>
            <Input style={{ width: '149px' }} id="actionSearchResults" placeholder='Search...' onChange={onActionSearchChange} />
            <br />
            <br />
            <Button onClick={() => {
                AddModal();
                dispatch({ type: actionModalSliceDispatch.setActionToAdd, payload: new Action() });
                dispatch({ type: actionViewerSliceDispatch.setCurrentAction, payload: new Action() });
                dispatch({ type: actionViewerSliceDispatch.setIndexOverride, payload: maxIndex });
            }}>
                Add new Action
            </Button>
            {addModal && <ActionModal />}
            {editModal && <ActionModal />}
            <List
                dataSource={actionSearchResults?.sort((a: any, b: any) => a.event.type > b.event.type ? 1 : -1)}
                renderItem={(currentAction: any, index: number) => (
                    <div key={"actions_" + index}>
                        <List.Item key={index}>
                            <Button onClick={() => {
                                EditModal();
                                dispatch({ type: actionModalSliceDispatch.setActionToAdd, payload: currentAction });
                                dispatch({ type: actionViewerSliceDispatch.setCurrentAction, payload: currentAction });
                                dispatch({ type: actionViewerSliceDispatch.setIndexOverride, payload: currentAddressStart + index });
                            }}>
                                Edit
                            </Button>
                            <Button id={currentAction.actionId} onClick={HandleDelete}>Delete</Button>
                            {getRuleTextFromEvent(currentAction.event)}{currentAction.event} - {currentAction.func}
                            {currentAction.params.map((fieldName: any) =>
                                <List.Item key={fieldName}>
                                    {fieldName}
                                </List.Item>)}
                        </List.Item>
                    </div>
                )}
            />
        </div>

    return (allActions)

}

export default ActionViewer;